/**
 * Hộp thoại form dùng chung — port của `openDialog` trong views/users.js.
 *
 * Tách ra vì màn hình quản lý danh mục (B2) cần đúng hành vi đó cho Hộ và Vườn, và
 * bản thứ ba chép tay sẽ là bản đầu tiên quên `try/catch` quanh `onSubmit` — lỗi
 * ngoài dự kiến bị nuốt, nút Lưu bấm không ra gì và không báo gì (sự cố 2026-08-08).
 *
 * `onSubmit` trả về chuỗi lỗi để hiện trong hộp thoại, hoặc không trả gì khi thành
 * công (lúc đó hộp thoại tự đóng).
 */
import { el, esc } from './util.js';

export function openFormDialog({ title, bodyHtml, submitLabel = 'Lưu', submitIcon = 'save', onSubmit, onMount }) {
  const backdrop = el('div', 'dialog-backdrop');
  const form = el('form', 'dialog');
  form.noValidate = true;
  form.innerHTML = `
    <div class="dialog-head">
      <h3>${esc(title)}</h3>
      <button class="icon-btn" type="button" data-act="close" aria-label="Đóng"><span class="ms">close</span></button>
    </div>
    <div class="dialog-body">${bodyHtml}</div>
    <div class="dialog-error error-text" hidden></div>
    <div class="dialog-actions">
      <button class="btn btn-text" type="button" data-act="cancel">Huỷ</button>
      <button class="btn" type="submit"><span class="ms">${esc(submitIcon)}</span>${esc(submitLabel)}</button>
    </div>`;

  backdrop.appendChild(form);
  document.body.appendChild(backdrop);

  const close = () => {
    backdrop.remove();
    document.removeEventListener('keydown', onKey);
    window.removeEventListener('hashchange', close);
  };
  const onKey = (e) => {
    if (e.key === 'Escape') close();
  };
  document.addEventListener('keydown', onKey);
  // Hộp thoại gắn vào `document.body`, router chỉ dọn `#view` — không đóng ở đây thì một
  // liên kết trong hộp thoại (vd "tạo vườn mới") để nó đè lên trang kế tiếp.
  window.addEventListener('hashchange', close);
  form.querySelector('[data-act="close"]').addEventListener('click', close);
  form.querySelector('[data-act="cancel"]').addEventListener('click', close);
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });

  const errBox = form.querySelector('.dialog-error');
  const submitBtn = form.querySelector('button[type="submit"]');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errBox.hidden = true;
    submitBtn.disabled = true;
    try {
      const loi = await onSubmit(form);
      if (loi) {
        // Cho phép trả về HTML (ví dụ kèm liên kết sang hộ đang giữ CCCD trùng).
        if (typeof loi === 'object' && loi.html) errBox.innerHTML = loi.html;
        else errBox.textContent = loi;
        errBox.hidden = false;
        return;
      }
      close();
    } catch (err) {
      // Lỗi ngoài dự kiến (bug trong onSubmit) phải hiện ra ngay tại hộp thoại —
      // không có nhánh này thì Promise treo im lặng và nút Lưu trông như hỏng.
      console.error('[form-dialog] lỗi khi lưu', err);
      errBox.textContent = err?.message || 'Đã xảy ra lỗi không xác định.';
      errBox.hidden = false;
    } finally {
      submitBtn.disabled = false;
    }
  });

  onMount?.(form);
  form.querySelector('input, select, textarea')?.focus();
  return { close, form };
}
